<template>
    <div class="t_login_body">
        <img src="../assets/img/logo2.png" class="t_new_logo" alt="">
        <div class="t_loginbox" v-if="boxtype==1">
            <div class="t_login_title">账号登录</div>
            <el-input style="margin-bottom: 30px;" class="t_login_input" v-model="loginobj.username" placeholder="账号"  clearable />
            <el-input style="margin-bottom: 10px;" class="t_login_input" type="password" v-model="loginobj.password" placeholder="密码"  clearable />
            <div @click="changezc(3)" style="text-align: right;color:#4F46E5;cursor:pointer;margin-bottom: 66px;width: 400px;">忘记账号密码？</div>
            <el-button style="color: white;" class="t_login_input" @click="loginbtn" color="#4F46E5" type="primary">登录</el-button>
            <div style="margin-top: 10px;">没有账号？<span style="color:#4F46E5;cursor:pointer" @click="changezc(2)">前往注册</span></div>
        </div>
        <!-- 注册 -->
        <div class="t_loginbox" v-if="boxtype==2">
            <div style="margin-bottom: 20px;font-size: 31px;" >注册账号</div>
            <el-input class="t_login_input" style="margin-bottom: 30px;" v-model="createobj.username" placeholder="账号"  clearable />
            <el-input class="t_login_input" style="margin-bottom: 30px;" type="password" v-model="createobj.password" placeholder="密码大于8位，字母加数字"   clearable />
            <el-input class="t_login_input" style="margin-bottom: 30px;" v-model="createobj.phone" placeholder="手机号"  clearable />
            <div class="t_yzm_input" >
                <el-input class="t_login_input" style="width: 250px;" v-model="createobj.phone_code" placeholder="验证码"  clearable />
                <div class="t_yzm" @click="getcode('register')">{{ codemsg }}</div>
            </div>
            
            <el-button @click="zhuce" class="t_login_input" style="color: white;"  color="#4F46E5" type="primary">注 册</el-button>
            <div style="margin-top: 10px;">已有账号？<span style="color:#4F46E5;cursor:pointer" @click="changezc(1)">前往登录</span></div>
        </div>
        <!-- 忘记密码 -->
         <div  class="t_loginbox" v-if="boxtype==3">
            <div style="margin-bottom: 20px;font-size: 31px;" >忘记账号密码</div>
            
            <!-- 第一步 -->
            <div v-if="forgetstep==1">
                <el-input class="t_login_input" style="margin-bottom: 30px;" v-model="forgetobj.phone" placeholder="手机号"  clearable />
                <div class="t_yzm_input" >
                    <el-input class="t_login_input" style="width: 250px;" v-model="forgetobj.phone_code" placeholder="验证码"  clearable />
                    <div class="t_yzm" @click="getcode('reset_password')">{{ codemsg }}</div>
                </div>
                <el-button @click="forget(2)" class="t_login_input" style="color: white;"  color="#4F46E5" type="primary">确定</el-button>
            </div>
            <!-- 第二步 -->
            <div v-if="forgetstep==2">
                <div style="text-align: center;color:#999999;">您的账号名称：</div>
                <div style="text-align: center;color:#393939;font-size: 23px;margin-top: 15px;margin-bottom: 30px;">{{ nowusername }}</div>
                <el-button @click="forget(3)" class="t_login_input" style="color: white;"  color="#4F46E5" type="primary">重置密码</el-button>
            </div>
            <!-- 第三步 -->
            <div v-if="forgetstep==3">
                <el-input class="t_login_input" style="margin-bottom: 30px;" type="password" v-model="forgetobj.password" placeholder="密码大于8位，字母加数字"   clearable />
                <el-input class="t_login_input" style="margin-bottom: 30px;" type="password" v-model="forgetobj.password_confirmation" placeholder="再次输入密码"   clearable />
                <el-button @click="forget(1)" class="t_login_input" style="color: white;"  color="#4F46E5" type="primary">确认修改</el-button>
            </div>
            <div style="margin-top: 10px;"><span style="color:#4F46E5;cursor:pointer" @click="changezc(1)">前往登录</span></div>
         </div>
         <div v-if="boxtype==4" class="t_choose_comp">
            <!-- 选主体 -->
             <el-page-header @back="goBack">
                <template #content>
                <span style="font-weight: bold;">请选择主体</span>
                </template>
            </el-page-header>
            <div class="t_choose_inner">
                <div v-for="(item,index) in allcomp.data" :key="index" class="t_choose_comp_item" @click="choosecomp(item)">
                    <div style="display: flex;align-items: center;">
                        <img src="../assets/img/compitem.png" style="width: 58px;height: 58px;border-radius: 50%;margin-right: 10px;" alt="">
                        <div style="width: 300px;">
                            <div style="text-align: left;font-size:21px">{{item.corp_name}}</div>
                            <div class="t_choose_comp_item_info" >
                                <div >
                                    <span :style="{ color: getDeviceColor(item) }">{{ item.total_online_devices }}/{{ item.total_devices }}</span>设备在线
                                </div>
                                <div style="margin-left: 20px;">
                                    粉丝数：<span style="color:black;font-weight: bold;">{{ item.customer_count }}</span>
                                </div>
                                
                            </div>
                        </div>
                        
                    </div>
                    
                    <span v-if="item.selected==1" style="font-size: 14px;color:#31CC31">已开启</span>
                    <!-- 选中图标 -->
                    <el-icon style="font-size: 19px;color:#31CC31" v-if="choosecompdata.data.includes(item)||item.selected==1"><Select /></el-icon>
                </div>
                
            </div>
            
            <el-button style="color: white;margin-top: 30px;" class="t_login_input" @click="confirmcomp"  color="#4F46E5" type="primary">确认</el-button>
         </div>
    </div>

    <!-- 注册成功，立即登录 -->
    <el-dialog
        v-model="isshowtologin"
        title=""
        width="500px"
        :close-on-click-modal="false"
    >
        <div style="display: flex;flex-direction: column;align-items: center;">
            <div style="font-size: 21px;margin-bottom: 20px;">注册成功</div>
            <el-button size="large" @click="tologin" color="#4F46E5" type="primary">立即登录</el-button>
        </div>
    </el-dialog>

    <!-- 注册失败 -->
    <el-dialog
        v-model="isshowfailed"
        title=""
        width="500px"
        :close-on-click-modal="false"
    >
        <div style="display: flex;flex-direction: column;align-items: center;">
            <div style="font-size: 21px;margin-bottom: 20px;">您还未绑定任企微主体账号</div>
            <el-button size="large" @click="tobind" color="#4F46E5" type="primary">绑定企微账号</el-button>
        </div>
    </el-dialog>
    <!-- 添加主体 -->
    <peizhibus v-if="isshowpz" :isshowpz="isshowpz" :bjitem="bjitem" :fromtype="1" @addbus="addbus" @closedpz="closedpz" />
</template>
<script setup>
import { ElMessage } from 'element-plus'
import { ref, reactive,  provide, onBeforeMount, onMounted,watch,inject } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import  peizhibus  from '../components/peizhibus.vue'
import { login,getcompcode,newlogin,newauth,newoutlogin,newgetcomp,newentercomp,newcreateuser,newsendsms,newfinduser,neweditforgetpwd} from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()

//扫码链接
const _url=inject('_url')
//动态获取接口地址
const _url2 = inject('_url2')

//登录还是注册,1登录，2 注册，3 忘记密码 4 选主体
const boxtype = ref(1)
//切换
const changezc = (type)=>{
    if(type==2){
        //转注册
        boxtype.value = 2
    }else if(type==1){
        //转登录
        boxtype.value = 1
    }else if(type==3){
        //转忘记密码
        boxtype.value = 3
        forgetstep.value = 1
    }

    //清空
    loginobj.username = ''
    loginobj.password = ''

    createobj.username = ''
    createobj.password = ''
    createobj.phone = ''
    createobj.phone_code = ''

    forgetobj.phone = ''
    forgetobj.phone_code = ''
    forgetobj.password = ''
    forgetobj.password_confirmation = ''

}

//忘记密码步骤
const forgetstep = ref(1)
//下一步
const forget = (val)=>{
    if(val==1){
        var obj = {
            phone:forgetobj.phone,
            phone_code:forgetobj.phone_code,
            password:forgetobj.password,
            password_confirmation:forgetobj.password_confirmation

        }
        neweditforgetpwd(obj).then((response) => {
                if(response.data.msg.code==0){
                    boxtype.value = 1
                    forgetstep.value = val
                    ElMessage({
                        message: '修改成功，前往登录',
                        type: 'success'
                    })

                }
            })
        

    }
    if(val == 2){
        var obj = {
            phone:forgetobj.phone,
            query_type:'reset_password',
            phone_code:forgetobj.phone_code
        }
        newfinduser(obj).then((response) => {
                if(response.data.msg.code==0){
                    console.log(response.data)
                    nowusername.value = response.data.data.username
                    forgetstep.value = val

                }
            })
    }
    if(val == 3){
        forgetstep.value = val

    }
}

//验证码
const codemsg=ref('获取验证码')
const time = ref(null)
//获取验证码
const getcode = (type)=>{

        // if(this.form.phonenum.length!=11){
        // 	this.$message.error('请输入正确手机号');
        // 	return
        // }
        if(codemsg.value=='获取验证码'){
            codemsg.value = 60
            time.value = setInterval(()=>{
                if(codemsg.value>0){
                    codemsg.value--
                }else{
                    codemsg.value = '获取验证码'
                    clearInterval(time.value)
                }
            },1000)

            if(type=='register'){
                var obj = {
                    phone:createobj.phone,
                    event:'register'
                }
            }else if(type=='reset_password'){
                var obj = {
                    phone:forgetobj.phone,
                    event:'reset_password'
                }
            }
            
            
            newsendsms(obj).then((response) => {
                if(response.data.msg.code==0){
                    ElMessage({
                        message: '发送成功',
                        type: 'success'
                    })
                }
            })
        }

    }

//注册成功，立即登录
const isshowtologin = ref(false)
const tologin = ()=>{
    isshowtologin.value = false
    boxtype.value = 1
}
//注册失败
const isshowfailed = ref(false)
const tobind = ()=>{
    isshowfailed.value = false
}


//公司code列表
const complist = reactive({
    data:[]
})
//选择的code
onMounted(() => {
    console.log('onMounted')
    // getcompcode(_url2).then((response)=>{
    //     console.log('获取code')
    //     console.log(response)
    //     complist.data = response.data.result
    // })
    // newauth().then((response)=>{
    //     if (response.data.msg.code == 0) {
    //          console.log('用户信息-登录')
    //          console.log(response.data.data.id)
    //          if(response.data.data.id){
    //             router.push({path:'/navhome'})
    //          }
           
    //     }
    // })
})
//选择公司id
const choosecompid = reactive({
    data:{}
})


//成员登录链接
// const megerlink = "https://open.work.weixin.qq.com/wwopen/sso/qrConnect?appid=ww94b9938e6d495196&agentid=1000022&redirect_uri="+encodeURIComponent(_url)

//管理员登录链接
const adminlink = ref('')
//扫码登录
// const sao_login = ()=>{
//     adminlink.value = "https://open.work.weixin.qq.com/wwopen/sso/qrConnect?appid="+choosecompid.data.corpId+"&agentid="+choosecompid.data.agentId+"&redirect_uri="+encodeURIComponent(_url)
// }

//当前tab
const activeName = ref('first')
//登录参数
const loginobj = reactive({
    username:'',
    password:''
})

//注册参数
const createobj = reactive({
    username:'',
    password:'',
    phone:'',
    phone_code:''
})

//忘记密码
const forgetobj = reactive({
    phone:'',
    query_type:'reset_password',
    phone_code:'',
    password:'',
    password_confirmation:''
})

//账号名
const nowusername = ref('')

//注册
const zhuce = ()=>{
        newcreateuser(createobj).then((response) => {
            console.log('注册')
            console.log(response)
            if(response.data.msg.code==0){
                ElMessage({
                    message: '注册成功',
                    type: 'success'
                })
                boxtype.value = 1
            }
        })
}

//是否显示注册主体
const isshowpz = ref(false)

//编辑数据
const bjitem = reactive({
  data:{}
})


//确认添加主体
const addbus = ()=>{
    isshowpz.value = false
    router.push({path:'/navhome'})
}
//关闭
const closedpz = ()=>{
    isshowpz.value = false
}

//是否显示登录框
// const isshowlogin = ref(true)
//登录
const loginbtn = ()=>{
    
    newlogin(loginobj).then((response) => {
        console.log('登录')
        console.log(response)
        if(response.data.msg.code==0){
            $cookies.set("fanstoken",response.data.data.token )
            // $cookies.set("fansavatar",response.data.result.userInfo.avatar )
            // $cookies.set("fansusername",response.data.data.username )
            // $cookies.set("fanscorpId",response.data.result.userInfo.corpId )
            // $cookies.set("fanscorpname",response.data.result.userInfo.username )
            // $cookies.set("fanscorpphone",response.data.result.userInfo.phone )


            ElMessage({
                message: '登录成功',
                type: 'success'
            })

            router.push({path:'/navhome'})

            //是否已经绑定主体
            // if(response.data.data.is_bind_wework){
            //     //获取主体
            //     newgetcomp().then((response)=>{
            //         console.log('获取主体')
            //         console.log(response)
            //         if(response.data.msg.code==0){
            //             allcomp.data = response.data.data
            //             // isshowlogin.value = false
            //             boxtype.value = 4
            //         }
            //     })
            // }else{
            //     //没有主体
            //     isshowpz.value = true
            // }
            
            
            // router.push({path:'/navhome'})
        }
    })
    
}
//返回登录页
const goBack = async ()=>{
    boxtype.value = 1
    try {
        await newoutlogin()
    } catch (error) {
        // 服务端退出失败不阻断本地退出。
    }
    choosecompdata.data = []
    $cookies.set("fanstoken", '')
    ElMessage({
        message: '退出成功',
        type: 'success',
    })
}
//全部主体
const allcomp = reactive({
    data:[
        {
            id:1,
            name:'主体1',
            selected:0
        },
        {
            id:2,
            name:'主体2',
            selected:0
        }
    ]
})



//选中主体
const choosecompdata = reactive({
    data:[]
})

//点击，增加或减少主体
const choosecomp = (item)=>{
    if(item.selected!=1){
        if(choosecompdata.data.includes(item)){
            choosecompdata.data = choosecompdata.data.filter(i=>i.id != item.id)
        }else{
            choosecompdata.data[0] = item
        }
    }
    
}
//确认
const confirmcomp = ()=>{
    if(choosecompdata.data.length == 0){
        ElMessage.error('请选择主体')
        return
    }
   console.log(choosecompdata.data)
   newentercomp({
    employee_id:choosecompdata.data[0].employee_id
   }).then((response)=>{
    console.log('进入主体')
    console.log(response)
    if(response.data.msg.code==0){
        // ElMessage({
        //     message: '进入主体成功',
        //     type: 'success',
        //   })
          router.push({path:'/navhome'})
    }
   })
   
}

//根据设备数量计算颜色
const getDeviceColor = (item) => {
  if (item.total_devices === 0) {
    return 'black';
  } else if (item.total_online_devices === item.total_devices) {
    return '#31CC31'; // 绿色
  } else {
    return 'red'; // 红色
  }
}
</script>
<style scoped>
    .t_new_logo{
        position: fixed;
        top: 70px;
        left: 70px;
        width: 180px;
    }
    .t_login_body{
        width: 100vw;
        height: calc(100vh - 40px);
        display: flex;
        justify-content: right;
        align-items: center;
        background-image: url('../assets/img/fansbg.jpg');
        background-size: cover;
    }
    .t_loginbox{
        width: 540px;
        text-align: center;
        padding:150px 50px 150px 50px;
        background-color: white;
        border-radius: 20px;
        box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .10);
        margin-right: 70px;
    }
    .t_choose_comp{
        width: 540px;
        text-align: center;
        padding: 50px;
        background-color: white;
        border-radius: 20px;
        box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .10);
        margin-right: 70px;
        height: 692px;
        box-sizing: border-box;
    }
    .t_login_title{
        margin-bottom: 50px;
        font-size: 31px;
        font-weight: bold;
    }
    .t_login_sao{
        background-color: #4F46E5;
        color: white;
        font-weight: bold;
        border-radius: 5px;
        font-size: 15px;
        margin-top: 20px;
        margin-bottom: 20px;
        display: block;
        padding: 5px;
    }
        .t_login_input{
        width: 400px;
        height: 68px;
        border-radius: 12px;
        /* overflow: hidden; */
        font-size: 21px;
    }
    :deep(.t_login_input .el-input__wrapper){
        box-shadow: none;
        border: 1px solid rgb(227, 232, 241);
        border-radius: 12px;
    }
    .t_choose_inner{
        margin-top: 50px;
        width: 100%;
        height: 420px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .t_choose_comp_item{
        border: 1px solid #e3e8f1;
        font-size: 17px;
        font-weight: 500;
        padding: 0 10px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 12px;
        margin-bottom: 10px;
        padding: 15px;
    }
    .t_choose_comp_item:hover{
        background-color: #F9F9F9;
    }
    .t_choose_comp_confirm{
        width: 230px;
        line-height: 40px;
        background-color: #4F46E5;
        color: white;
        text-align: center;
        border-radius: 8px;
        margin-top: 40px;
        cursor: pointer;
    }
    .t_choose_comp_item_info{
        display: flex;
        align-items: center;
        font-size: 15px;
        color: #999999;
        font-weight: normal;
        margin-top: 5px;
    }
    .t_yzm{
        color:#4F46E5;
        cursor: pointer;
    }
    .t_yzm_input{
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;
        width: 400px;
        align-items: center;
        border:1px solid rgb(227, 232, 241);
        border-radius: 12px;
        box-sizing: border-box;
        padding-right: 15px;
        margin-left: auto;
        margin-right: auto;
    }
    :deep(.t_yzm_input .el-input__wrapper){
            border: none;
        }
</style>